/* Bonsai Matcha — Subscription badges + localized upsell popup v9 */
(function () {
  var lang = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  var copies = {
    en: {
      subscribeTitle: 'Subscribe and Save',
      popular: 'Most Popular',
      value: 'Best Value',
      headline: 'Make it a <em style="font-style:italic">ritual</em>',
      body: 'Never run out. Switch to a subscription and save on every order.',
      monthlyLabel: 'Save 10% — Monthly delivery',
      monthlySub: 'Delivered once a month',
      biweeklyLabel: 'Save 15% — Every 2 weeks',
      biweeklySub: 'Never run out · best value',
      dismiss: 'No thanks, one-time purchase',
      close: 'Close'
    },
    es: {
      subscribeTitle: 'Suscríbete y ahorra',
      popular: 'Más popular',
      value: 'Mejor precio',
      headline: 'Hazlo un <em style="font-style:italic">ritual</em>',
      body: 'Que nunca te falte. Suscríbete y ahorra en cada pedido.',
      monthlyLabel: 'Ahorra un 10 % — Entrega mensual',
      monthlySub: 'Entrega una vez al mes',
      biweeklyLabel: 'Ahorra un 15 % — Cada 2 semanas',
      biweeklySub: 'Que nunca te falte · la mejor opción',
      dismiss: 'No, gracias; compra única',
      close: 'Cerrar'
    },
    de: {
      subscribeTitle: 'Abonnieren und sparen',
      popular: 'Am beliebtesten',
      value: 'Bestes Angebot',
      headline: 'Mach es zum <em style="font-style:italic">Ritual</em>',
      body: 'Sorge dafür, dass dir Matcha nie ausgeht. Abonniere und spare bei jeder Bestellung.',
      monthlyLabel: '10 % sparen — Monatliche Lieferung',
      monthlySub: 'Einmal im Monat geliefert',
      biweeklyLabel: '15 % sparen — Alle 2 Wochen',
      biweeklySub: 'Nie ohne Matcha · bestes Angebot',
      dismiss: 'Nein danke, einmalig kaufen',
      close: 'Schließen'
    },
    fr: {
      subscribeTitle: 'Abonnez-vous et économisez',
      popular: 'Le plus populaire',
      value: 'Meilleur choix',
      headline: 'Faites-en un <em style="font-style:italic">rituel</em>',
      body: 'Ne soyez jamais à court. Abonnez-vous et économisez sur chaque commande.',
      monthlyLabel: 'Économisez 10 % — Livraison mensuelle',
      monthlySub: 'Livré une fois par mois',
      biweeklyLabel: 'Économisez 15 % — Toutes les 2 semaines',
      biweeklySub: 'Ne soyez jamais à court · meilleur choix',
      dismiss: 'Non merci, achat unique',
      close: 'Fermer'
    },
    nl: {
      subscribeTitle: 'Abonneer en bespaar',
      popular: 'Meest populair',
      value: 'Beste keuze',
      headline: 'Maak er een <em style="font-style:italic">ritueel</em> van',
      body: 'Zorg dat je nooit zonder zit. Neem een abonnement en bespaar op elke bestelling.',
      monthlyLabel: 'Bespaar 10% — Maandelijkse levering',
      monthlySub: 'Eén keer per maand bezorgd',
      biweeklyLabel: 'Bespaar 15% — Elke 2 weken',
      biweeklySub: 'Nooit zonder matcha · beste keuze',
      dismiss: 'Nee bedankt, eenmalige aankoop',
      close: 'Sluiten'
    },
    it: {
      subscribeTitle: 'Abbonati e risparmia',
      popular: 'Più popolare',
      value: 'Miglior scelta',
      headline: 'Rendilo un <em style="font-style:italic">rituale</em>',
      body: 'Non rimanere mai senza. Abbonati e risparmia su ogni ordine.',
      monthlyLabel: 'Risparmia il 10% — Consegna mensile',
      monthlySub: 'Consegna una volta al mese',
      biweeklyLabel: 'Risparmia il 15% — Ogni 2 settimane',
      biweeklySub: 'Mai senza matcha · la scelta migliore',
      dismiss: 'No grazie, acquisto singolo',
      close: 'Chiudi'
    },
    hr: {
      subscribeTitle: 'Pretplatite se i uštedite',
      popular: 'Najpopularnije',
      value: 'Najbolji izbor',
      headline: 'Neka postane <em style="font-style:italic">ritual</em>',
      body: 'Nikad nemojte ostati bez matche. Pretplatite se i uštedite pri svakoj narudžbi.',
      monthlyLabel: 'Uštedite 10 % — Mjesečna dostava',
      monthlySub: 'Dostava jednom mjesečno',
      biweeklyLabel: 'Uštedite 15 % — Svaka 2 tjedna',
      biweeklySub: 'Uvijek imajte matchu · najbolji izbor',
      dismiss: 'Ne hvala, jednokratna kupnja',
      close: 'Zatvori'
    },
    sv: {
      subscribeTitle: 'Prenumerera och spara',
      popular: 'Mest populär',
      value: 'Bästa valet',
      headline: 'Gör det till en <em style="font-style:italic">ritual</em>',
      body: 'Se till att du aldrig får slut. Prenumerera och spara på varje beställning.',
      monthlyLabel: 'Spara 10 % — Leverans varje månad',
      monthlySub: 'Leverans en gång i månaden',
      biweeklyLabel: 'Spara 15 % — Leverans varannan vecka',
      biweeklySub: 'Aldrig utan matcha · bästa valet',
      dismiss: 'Nej tack, engångsköp',
      close: 'Stäng'
    }
  };
  var copy = copies[lang] || copies.en;
  var subscriptionTitles = Object.keys(copies).map(function (locale) {
    return copies[locale].subscribeTitle;
  });

  /* 1. SUBSCRIPTION LABELS + BADGES */
  /* Match "10%" / "10 %" as a discount, not any 10 or 15 inside a price. */
  var TEN_PERCENT = /(^|[^\d.,])10\s?%/;
  var FIFTEEN_PERCENT = /(^|[^\d.,])15\s?%/;

  function addBadges() {
    var fieldset = document.querySelector('.shopify_subscriptions_fieldset');
    if (!fieldset) return false;

    var groupNames = document.querySelectorAll('.group_name');
    groupNames.forEach(function (name) {
      /* Only write when it differs: every write wakes the page watcher below, and an unconditional write loops forever and freezes the page. */
      if (name.textContent !== copy.subscribeTitle && subscriptionTitles.indexOf((name.textContent || '').trim()) !== -1) {
        name.textContent = copy.subscribeTitle;
      }
    });

    var labels = fieldset.querySelectorAll('label');
    if (!labels.length) return false;
    labels.forEach(function (label) {
      if (label.querySelector('.bonsai-badge')) return;
      var text = label.textContent || '';
      if (TEN_PERCENT.test(text)) {
        var b = document.createElement('span');
        b.className = 'bonsai-badge';
        b.textContent = copy.popular;
        b.style.cssText = 'display:inline-block;background:#4a7c59;color:#fff;font-size:0.6rem;font-weight:700;padding:2px 7px;border-radius:3px;margin-left:8px;vertical-align:middle;letter-spacing:0.05em;text-transform:uppercase;';
        label.appendChild(b);
      } else if (FIFTEEN_PERCENT.test(text)) {
        var b2 = document.createElement('span');
        b2.className = 'bonsai-badge';
        b2.textContent = copy.value;
        b2.style.cssText = 'display:inline-block;background:#c8570a;color:#fff;font-size:0.6rem;font-weight:700;padding:2px 7px;border-radius:3px;margin-left:8px;vertical-align:middle;letter-spacing:0.05em;text-transform:uppercase;';
        label.appendChild(b2);
      }
    });
    return true;
  }

  [200, 400, 900, 1800, 3500].forEach(function (delay) {
    setTimeout(addBadges, delay);
  });

  function watchSubscriptionBlock() {
    var observer = new MutationObserver(addBadges);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 10000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSubscriptionBlock, { once: true });
  } else {
    watchSubscriptionBlock();
  }

  /* 2. GALLERY FIX */
  function hideExtraGalleryImages() {
    var media = document.querySelector('.product-information__media');
    if (!media) return false;
    var grid = media.querySelector('.media-gallery__grid');
    if (grid) {
      var items = grid.querySelectorAll('.product-media-container');
      if (items.length <= 1) return true;
      for (var i = 1; i < items.length; i++) {
        items[i].style.setProperty('display', 'none', 'important');
      }
      items[0].style.setProperty('grid-column', '1 / -1', 'important');
      return true;
    }
    return false;
  }
  var galleryAttempts = 0;
  var galleryTimer = setInterval(function () {
    if (hideExtraGalleryImages() || ++galleryAttempts >= 25) {
      clearInterval(galleryTimer);
    }
  }, 250);

  /* 3. SUBSCRIPTION UPSELL POPUP */
  var PLAN_MONTHLY  = '689980309844';
  var PLAN_BIWEEKLY = '689980342612';
  var STORAGE_KEY   = 'bm_sub_popup_seen';
  var COOLDOWN_DAYS = 7;
  var skipNext = false;

  /* Storage can be blocked by the shopper's browser; that must never stop an add to cart. */
  function isOnCooldown() {
    try {
      var ts = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
      return ts && (Date.now() - ts) < COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
    } catch (e) {
      return true;
    }
  }

  function markSeen() {
    try { localStorage.setItem(STORAGE_KEY, Date.now().toString()); } catch (e) {}
  }

  function getProductUrl() {
    return window.location.origin + window.location.pathname;
  }

  function readField(body, field) {
    if (!body) return null;
    if (body instanceof FormData || body instanceof URLSearchParams) return body.get(field);
    if (typeof body !== 'string') return null;
    var match = body.match(new RegExp('(?:^|[&?])' + field + '=([^&\\s]*)'));
    if (match) return decodeURIComponent(match[1]);
    try {
      var json = JSON.parse(body);
      var item = (json.items && json.items[0]) || json;
      return item[field] != null ? String(item[field]) : null;
    } catch (e) {
      return null;
    }
  }

  function hasSellingPlanInBody(body) {
    var sp = readField(body, 'selling_plan');
    return !!(sp && sp !== 'one_time' && sp !== 'onetime');
  }

  /* Only offer the popup for the product on this page that actually has the subscription block.
     On collection pages, search, the home page or for other products the add goes straight through. */
  function isThisPagesSubscriptionProduct(body) {
    if (!document.querySelector('.shopify_subscriptions_fieldset')) return false;
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (!meta || !meta.variants) return false;
    var id = readField(body, 'id');
    if (!id) return false;
    return meta.variants.some(function (v) { return String(v.id) === String(id); });
  }

  function buildPopup(onDismiss) {
    var overlay = document.createElement('div');
    overlay.id = 'bm-sub-popup-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(28,43,26,0.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;font-family:"DM Mono",monospace;';
    var box = document.createElement('div');
    box.style.cssText = 'background:#FDFAF5;max-width:400px;width:100%;padding:40px 32px 28px;position:relative;border-radius:3px;text-align:center;';
    var close = document.createElement('button');
    close.innerHTML = '&times;';
    close.setAttribute('aria-label', copy.close);
    close.style.cssText = 'position:absolute;top:12px;right:16px;background:none;border:none;font-size:22px;color:#8A8A80;cursor:pointer;line-height:1;padding:0;';
    var headline = document.createElement('div');
    headline.innerHTML = copy.headline;
    headline.style.cssText = 'font-family:"Cormorant Garamond",Georgia,serif;font-weight:300;font-size:2rem;color:#1C2B1A;margin:0 0 10px;line-height:1.15;';
    var body = document.createElement('p');
    body.textContent = copy.body;
    body.style.cssText = 'font-size:0.75rem;color:#8A8A80;margin:0 0 24px;line-height:1.7;letter-spacing:0.02em;';
    var opts = document.createElement('div');
    opts.style.cssText = 'display:flex;flex-direction:column;gap:8px;margin-bottom:14px;';
    var productUrl = getProductUrl();

    function makeOption(label, sub, planId, bg) {
      var btn = document.createElement('a');
      btn.href = productUrl + '?selling_plan=' + planId;
      btn.style.cssText = 'display:block;padding:13px 16px;background:' + bg + ';color:#FDFAF5;text-decoration:none;border-radius:2px;transition:opacity 0.15s;';
      var labelEl = document.createElement('div');
      labelEl.textContent = label;
      labelEl.style.cssText = 'font-size:0.68rem;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;';
      var subEl = document.createElement('div');
      subEl.textContent = sub;
      subEl.style.cssText = 'font-size:0.63rem;opacity:0.72;margin-top:3px;letter-spacing:0.05em;';
      btn.appendChild(labelEl);
      btn.appendChild(subEl);
      btn.onmouseenter = function () { btn.style.opacity = '0.85'; };
      btn.onmouseleave = function () { btn.style.opacity = '1'; };
      btn.addEventListener('click', function () { markSeen(); });
      return btn;
    }

    opts.appendChild(makeOption(copy.monthlyLabel, copy.monthlySub, PLAN_MONTHLY, '#1C2B1A'));
    opts.appendChild(makeOption(copy.biweeklyLabel, copy.biweeklySub, PLAN_BIWEEKLY, '#4A7C3F'));

    var dismiss = document.createElement('button');
    dismiss.textContent = copy.dismiss;
    dismiss.style.cssText = 'background:none;border:none;font-size:0.63rem;color:#8A8A80;letter-spacing:0.07em;cursor:pointer;text-decoration:underline;font-family:inherit;padding:4px 0;';

    function closePopup() {
      markSeen();
      if (document.body.contains(overlay)) document.body.removeChild(overlay);
      if (onDismiss) onDismiss();
    }

    close.addEventListener('click', closePopup);
    dismiss.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closePopup();
    });

    box.appendChild(close);
    box.appendChild(headline);
    box.appendChild(body);
    box.appendChild(opts);
    box.appendChild(dismiss);
    overlay.appendChild(box);
    return overlay;
  }

  function showPopup(onDismiss) {
    if (document.getElementById('bm-sub-popup-overlay')) return false;
    document.body.appendChild(buildPopup(onDismiss));
    return true;
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var args = arguments;
    /* Anything going wrong in the popup must fall through to a normal add to cart, never block it. */
    try {
      var url = typeof input === 'string' ? input : (input && input.url) ? input.url : '';
      var isCartAdd = url.indexOf('/cart/add') !== -1;
      if (isCartAdd && !skipNext && !isOnCooldown()) {
        var body = init && init.body;
        if (!hasSellingPlanInBody(body) && isThisPagesSubscriptionProduct(body)) {
          return new Promise(function (resolve, reject) {
            var shown = showPopup(function () {
              skipNext = true;
              originalFetch.apply(window, args).then(resolve, reject);
            });
            if (!shown) originalFetch.apply(window, args).then(resolve, reject);
          });
        }
      }
      if (isCartAdd) skipNext = false;
    } catch (e) {}
    return originalFetch.apply(window, args);
  };
})();
